<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="120px">
        <el-row>
          <el-col span="12">
            <el-form-item
              prop="name"
              label="问卷名称："
              :rules="[{ required: true, message: '请输入问卷名称', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.name"
                placeholder="请输入 问卷名称"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="dateRange"
              label="起止日期："
              :rules="[{ required: true, message: '请选择起止日期', trigger: 'change' }]"
            >
              <el-date-picker
                v-model="formData.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item
              prop="link"
              label="问卷链接："
              :rules="[{ required: true, message: '请输入问卷链接', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.link"
                placeholder="请输入 问卷链接"
                type="textarea"
                :rows="2"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { addApi, updateApi } from '@/api/call-system/questionnaire-manage/questionnaire-list';

export default {
  props: ['dialogType', 'projectId', 'rowData'],
  data() {
    return {
      // 表单数据
      formData: {
        dateRange: [],
      },
    };
  },
  created() {
    if (this.dialogType == 'edit') {
      this.formData = {
        id: this.rowData.id,
        name: this.rowData.name,
        dateRange: [this.rowData.startDate, this.rowData.endDate],
        link: this.rowData.link,
      };
    } else {
      this.formData.projectId = this.projectId;
    }
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? addApi : updateApi;
          this.formData.startDate = this.formData.dateRange[0];
          this.formData.endDate = this.formData.dateRange[1];
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
